import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import Sidebar from '../../../Components/Sidebar/Index.js'
import GuildCard from '../../../Components/Card/GuildCard.js'
import Navbar from '../../../Components/Navbar/Index.js'
import Subnav from '../../../Components/Navbar/Subnav.js'
import { SET_GUILDS } from '../../../Actions/Guilds'
import ProfileTrigger from '../../../Components/ProfileTrigger/Index.js'
import Loader from '../../../Components/Loader/Index.js'

class Groups extends Component {
    
    state = {
        loadingGuilds: false
    }

    componentDidMount() {
        const { user, guilds } = this.props;
        
        if(!user.token) {
            this.props.history.push('/')
        }

        if(!guilds.length) {
            this.setState({
                loadingGuilds: true
            })
        }

        this.props.actions.SET_GUILDS().then(()=> {
            this.setState({
                loadingGuilds: false
            })
        })
        document.body.classList.add('has-background');
    }

    componentWillUnmount() {
        document.body.classList.remove('has-background');
    }

    render() {
        const { user, guilds } = this.props
        const { loadingGuilds } = this.state


        return (
            <>
                <div className="o-page-wrap">
                    
                    <Sidebar />
                    <Navbar />
                    <Subnav />
                    <ProfileTrigger />

                    {
                        loadingGuilds && (
                            <Loader />
                        )
                    }

                    <div className="o-main-container o-main-container--spacing-big">
                        <h1>Groepen</h1>
                        {
                            guilds.map((item, i) => 
                                <GuildCard 
                                    key={`guild-wall-${i}`}
                                    group_id={`${item._id}`}
                                    title={`${item.title}`}
                                    sub_count={`${item.user_count}`}
                                    type="guild"
                                    group={item}
                                    isMember={(user.guilds && user.guilds.includes(item._id))}
                                />
                            )
                        }
                      
                        
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
        guilds: state.guilds.guilds
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_GUILDS}, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Groups))